module.exports = __webpack_public_path__ + "img/bb05.0b20df58.jpg";